<template>
  <van-popup v-model="showPage" position="bottom" @closed="onClosed">
    <van-row class="popTitle">
      <van-col span="4" />
      <van-col span="16" class="center" :style="'color:'+GetDiveMainBack()">{{ title }}</van-col>
      <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showPage=false" /></van-col>
    </van-row>
    <div class="dateRect">
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">完成情况</span></van-col>
        <van-col span="19" />
      </van-row>
      <table class="tableRect" cellspacing="0">
        <tr class="title" :style="'color:'+GetDiveMainBack()">
          <td>单元</td>
          <td>教练</td>
          <td>状态</td>
          <td>佣金</td>
        </tr>
        <tr v-for="(item,index) in CommissionOwnerList" :key="index">
          <td>{{ item.unitName }}</td>
          <td>{{ item.name }}</td>
          <td>{{ GetEnumText('Em_DiveUnitState',item.state) }}</td>
          <td :style="item.isGetCommission?'color:'+GetDiveMainBack():'color:#f00'">{{ item.isGetCommission?'可获得':'不可获得' }}</td>
        </tr>
      </table>
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">终止类型</span></van-col>
        <van-col span="19">
          <van-radio-group v-model="stopType" :checked-color="GetDiveMainBack()">
            <!-- <van-radio name="DropOut" class="radioItem">{{ GetEnumText('Em_LearningState','DropOut') }}</van-radio>
            <div class="remark">适用于顾客暂时终止行程,短期可能继续</div> -->
            <van-radio name="KeepStatusStart" class="radioItem">{{ GetEnumText('Em_LearningState','KeepStatusStart') }}</van-radio>
            <div class="remark">适用于顾客终止行程,本次不会继续,并且已经开始!</div>
            <van-radio name="KeepStatusUnStart" class="radioItem">{{ GetEnumText('Em_LearningState','KeepStatusUnStart') }}</van-radio>
            <div class="remark">适用于顾客终止行程,本次不会继续,并且尚未开始!</div>
            <van-radio name="Cancel" class="radioItem">{{ GetEnumText('Em_LearningState','Cancel') }}</van-radio>
            <div class="remark">适用于顾客完全终止行程,不在继续!</div>
          </van-radio-group>
        </van-col>
      </van-row>
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">申请说明</span></van-col>
        <van-col span="19">
          <van-field
            v-model="remark"
            style="padding:0;"
            rows="1"
            autosize
            type="textarea"
            placeholder="请输入变更说明(公开)"
          />
        </van-col>
      </van-row>
    </div>
    <div class="checkBoxRect">
      <van-checkbox v-model="checkSuccess" :checked-color="GetDiveMainBack()" class="checkBox">我确认变更用户状态,终止顾客行程,并自动通知用户核对进度!</van-checkbox>
      <van-button :disabled="!checkSuccess" :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="onChangeStudentState">终止行程</van-button>
    </div>

  </van-popup>
</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Field, Dialog, RadioGroup, Radio, Checkbox } from 'vant'
import { GetEnumText, MyNotify, getScoreText, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox
  },
  props: {
    // eslint-disable-next-line
    value: String,
    // eslint-disable-next-line
    title: {
      default: '终止顾客行程'
    }
  },
  data() {
    return {
      showPage: false,
      studentId: undefined,
      CommissionOwnerList: [],
      stopType: 'Cancel',
      remark: '',
      checkSuccess: false,
      buttonLoading: false
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.studentId = newValue
        this.showPage = true
        this.getDiveCommissionOwnerList()
      } else {
        this.studentId = undefined
        this.showPage = false
      }
    }

  },
  created() {
  },
  methods: {
    GetEnumText,
    MyNotify,
    getScoreText,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetColorMainLine,
    onClosed() {
      console.log('onClosed')
      this.$emit('input', undefined)
    },
    getDiveCommissionOwnerList() {
      request({
        url: '/DiveTrip/getDiveCommissionOwnerList',
        method: 'post',
        data: {
          studentId: this.studentId,
          isOther: false
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.CommissionOwnerList = response.data
      })
    },
    onChangeStudentState() {
      this.buttonLoading = true
      request({
        url: '/DiveTrip/StopDiveLearning',
        method: 'post',
        data: {
          remark: this.remark,
          studentId: this.studentId,
          state: this.stopType
        }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '终止课程成功,待用户确认后生效!', 2000)
        this.showPage = false
        this.$emit('reload')
      })
    }
  }
}
</script>

<style scoped>
.popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}
.tableRect{
    width: 100%;
    font-size: 0.8em;
}
.tableRect td{
    border:1px solid #fafafa;
    padding: 0.25em;
}

.tableRect .title{
    text-align: center;
}
.dateRect{
    padding: 0 0.5em;
}
.values{
  font-size: 0.8em;
  padding: 1em 0;
}
.values .remark{
    color: #999;
    font-size: 0.8em;
    padding-bottom: 0.5em;
}
.radioItem{
    padding: 0.25em;
}
.checkBoxRect{
    padding: 0.5em;
}
.checkBoxRect .checkBox{
    padding-bottom: 1em;
    font-size: 0.7em;
}
</style>
